<template>
    <div class="d-flex flex-wrap">
        <span
            :key="index"
            :tabindex="index"
            v-b-tooltip.hover.topright
            :title="degree.description"
            v-for="(degree, index) in mappedDegrees"
        >
            <b-button
                size="sm"
                :disabled="disabled"
                :class="getButtonClass(index)"
                :pressed="buttonIsPressed(degree.id)"
                :variant="getButtonVariant(degree.id)"
                @click="onClickDegree(degree)"
            >
                {{ degree.title }}
            </b-button>
        </span>
    </div>
</template>
<script>
import i18n from '@/i18n'
import { sortBy } from 'lodash'

const FLAT_BUTTON_CLASS = 'flat-button'
const FIRST_BUTTON_CLASS = 'first-button'
const LAST_BUTTON_CLASS = 'last-button'
const PRIMARY_CLASS = 'outline-primary'
const SECONDARY_CLASS = 'outline-secondary'
const DANGER_CLASS = 'outline-danger has-error'

export default {
    props: {
        state: Boolean,
        disabled: Boolean,
        hasScore: Boolean,
        isNullable: Boolean,
        model: [String, Number],
        degrees: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        mappedDegrees() {
            const degrees = sortBy(this.degrees, 'max_score')
            if (this.isNullable) {
                degrees.push({
                    id: null,
                    max_score: null,
                    title: i18n.t('form.button.notAbleToAnswer'),
                })
            }
            return degrees
        },
    },
    methods: {
        onClickDegree(degree) {
            this.$emit('change', degree.max_score, degree.id)
        },
        buttonIsPressed(degreeId) {
            return degreeId == this.model && this.hasScore
        },
        getButtonClass(index) {
            const isFirstButton = index == 0
            if (isFirstButton) {
                return FIRST_BUTTON_CLASS
            }

            const isLastButton = index + 1 == this.mappedDegrees.length
            if (isLastButton) {
                return LAST_BUTTON_CLASS
            }

            return FLAT_BUTTON_CLASS
        },
        getButtonVariant(degreeId) {
            if (this.state === false) {
                return DANGER_CLASS
            }

            if (!this.hasScore) {
                return SECONDARY_CLASS
            }

            if (this.disabled && this.model !== degreeId) {
                return SECONDARY_CLASS
            }

            if (this.model === degreeId) {
                return PRIMARY_CLASS
            }

            return SECONDARY_CLASS
        },
    },
}
</script>
<style scoped lang="sass">
$radius: .2rem

.flat-button
    border-radius: 0

.first-button
    border-radius: $radius 0 0 $radius

.last-button
    border-radius: 0 $radius $radius 0

.btn-outline-secondary
    color: #73818f
    border-color: #c8ced3
    &:hover
        background-color: white
    &:active
        background-color: white
    &:disabled
        opacity: 1
        pointer-events: none
        cursor: default !important
        background-color: transparent

.btn-outline-primary
    &:disabled
        opacity: 1
        color: white
        background-color: #20a8d8
        cursor: default !important
</style>
